export { default as AboutComponent } from './AboutComponent';
